<template>
  <div id="inicioCarrusel">
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
    >
      <!-- Text slides with image -->
      <b-carousel-slide
        v-for="(item, idxcar) in items"
        :key="`carr-${idxcar}`"
        :img-src="item.src"
      ></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "inicio",
  components: {},
  mounted() {
    //   this.$router.push({name: 'cuposAereos'});
  },
  beforeCreate() {},
  methods: {
    ...mapActions("carrito", {
      limpiarCarrito: "limpiar"
    }),
    init() {
      this.limpiarCarrito({ tipo: "c" });
      this.limpiarCarrito({ tipo: "h" });
      this.setApp();
    },
    async setApp() {
      await this.$store.dispatch("app/saveApp", this.$route.meta.app);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init();
    });
  },
  data() {
    return {
      items: [
        {
          src:
            "https://asback.allseasons.tur.ar/storage/media-links/47-slide1.jpeg"
        },
        {
          src:
            "https://asback.allseasons.tur.ar/storage/media-links/48-slide2.jpeg"
        },
        {
          src:
            "https://asback.allseasons.tur.ar/storage/media-links/49-slide-3.jpeg"
        },
        {
          src:
            "https://asback.allseasons.tur.ar/storage/media-links/50-slide-4.jpeg"
        },
        {
          src:
            "https://asback.allseasons.tur.ar/storage/media-links/51-slide-5.jpeg"
        }
      ],
      slide: 0
    };
  }
};
</script>
